import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { AsideNodeView } from "@/components/editor/nodeviews/AsideNodeView";

export const AsideBlock = Node.create({
  name: "asideBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      text: { default: "" },
      title: { default: "" },
      asideType: { default: "sidebar" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="aside-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "aside-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AsideNodeView);
  },
});
